import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeComponent } from '@theme/theme.component';
import { LayoutModule } from '@theme-layouts/layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { HotkeyModule } from 'angular2-hotkeys';
import { NgbModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TreeviewModule } from 'ngx-treeview';
import { MessageModule } from '@global-message/Message.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ScriptLoaderService } from '@global-services/script-loader.service';
import { PageService } from '@global-services/Page.service';
import { VbtInterceptor } from '@global-interceptor/vbt-interceptor';
import { ApiSendService } from '@global-services/ApiSend.service';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthModule } from '@auth/auth.module';
import { checkAuth } from '@auth/checkAuth';
import { ThemeRoutingModule } from '@theme/theme-routing.module';
import { ParameterService } from './vbt-ticari/common/_services/Parameter.service';
import { HeaderProfileModule } from '@theme/pages/default/header/header-profile/header-profile.module';





@NgModule({
  declarations: [
    ThemeComponent,
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ThemeRoutingModule,
    HttpClientModule,
    LayoutModule,
    CommonModule,
    HotkeyModule.forRoot(),
    AuthModule,
    NgSelectModule,
    MessageModule,
    //NgbModule.forRoot(),
    NgbModule,
    NgbDatepickerModule,
    BsDatepickerModule.forRoot(),
    TreeviewModule.forRoot(),
    HeaderProfileModule,
    PopoverModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    AgGridModule.withComponents([])
  ],
  exports: [
    RouterModule,
    MessageModule,
    PopoverModule
  ],
  providers: [
    ScriptLoaderService,
    checkAuth,
    PageService,
    ParameterService,
    ApiSendService,
    [
     { provide: HTTP_INTERCEPTORS, useClass: VbtInterceptor, multi: true },
      { provide: LocationStrategy, useClass: HashLocationStrategy }
    ],

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
  }
}
